<script lang="ts" setup>
import { ref, watch, type PropType } from "vue";
import { BreadcrumbType } from "@/app/common/types/breadcrumb.type";

const prop = defineProps({
  title: {
    type: String,
    default: ""
  },
  items: {
    type: Array as PropType<BreadcrumbType[]>,
    default: () => []
  },
  isStep: {
    type: Boolean,
    default: false
  },
});

const localItems = ref(prop.items as BreadcrumbType[]);

watch(
  () => prop.items,
  () => {
    localItems.value = prop.items;
  },
  {
    immediate: true,
    deep: true,
  },
);
</script>
<template>
  <div class="heading d-flex justify-space-between align-center pb-3">
    <h2 class="text-uppercase font-weight-bold">
      {{ title }}
    </h2>
    <v-breadcrumbs :items="localItems" class="breadcrumb-wrapper">
      <template v-slot:title="{ item, index }">
        <div :class="isStep ? 'step' : ''">
          <v-icon v-if="isStep" :icon="localItems[index].icon"
            :color="localItems[index].active ? 'primary' : ''"></v-icon>
          <span :class="localItems[index].active ? 'active' : ''">{{ $t(`t-${item.title}`) }}</span>
        </div>
      </template>
      <template #divider>
        <v-icon icon="ph-caret-right ph-sm"></v-icon>
      </template>
    </v-breadcrumbs>
  </div>
</template>
